import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, BadgeCheck, Users } from 'lucide-react';
interface Testimonial {
  name: string;
  age: number;
  avatar: string;
  title: string;
  body: string;
}
const testimonials: Testimonial[] = [{
  name: 'Mateo',
  age: 25,
  avatar: 'https://randomuser.me/api/portraits/men/62.jpg',
  title: 'Pensé que mi vida sexual se había acabado antes de empezar',
  body: "Me pasó una vez y me quería morir. Luego me pasó otra vez y directamente entré en pánico. No entendía nada, se supone que a mi edad esto no te pasa y te sentís un inútil. Empecé a evitar salir con chicas solo por el miedo a quedar mal. Compré 'El Código Maestro' buscando una salida y ahí entendí que mi problema no era físico, sino que el estrés me estaba bloqueando por completo sin que yo me diera cuenta. Apliqué los pasos del libro y a los pocos días sentí que mi cuerpo volvía a responder de verdad. Me quitó un peso de encima enorme y recuperé la confianza que había perdido."
}, {
  name: 'Carlos',
  age: 28,
  avatar: 'https://randomuser.me/api/portraits/men/46.jpg',
  title: 'La dopamina barata me tenía bloqueado',
  body: 'No lo sabía, pero estar todo el día en redes y viendo porno me tenía mal. Cuando mi novia quería intimidad la esquivaba como fuera, porque mi erección ya no era de piedra y me daba pánico fallar. Gracias al libro entendí que el problema no era ella, ni que yo estuviera roto; solo tenía que corregir mis hábitos. Seguí los pasos al pie de la letra y hoy mis erecciones volvieron a ser lo que eran. Mi vida sexual está más activa que nunca y ella no lo puede creer.'
}, {
  name: 'David',
  age: 33,
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  title: 'Recuperé la firmeza que creí perdida',
  body: 'Ya no era lo mismo de antes y me asusté. Sentía que cada vez me costaba más y llegué a pensar que mi única salida eran las pastillas azules, pero no quería depender de eso con apenas treinta y pocos. Al leer el libro entendí lo que me faltaba en mi diá a día y a mi cuerpo. Apliqué los cambios en mi comida y los ejercicios que recomiendan, y la diferencia fue total. Mi firmeza volvió a ser la de un pibe y lo mejor es que es natural. Me siento con una energía que no tenía hace años.'
}, {
  name: 'Sebastián',
  age: 37,
  avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
  title: 'Me decían que era el cansancio de la edad',
  body: "Siempre estaba cansado y en la cama simplemente no era el mismo de antes. Mi médico me decía que era 'normal' por el estilo de vida, pero yo no me resignaba a sentirme así a los 37. Al leer el libro descubrí que mi cuerpo estaba totalmente vacío de energía porque no le estaba dando lo que necesitaba. Hice los cambios que recomiendan y les juro que a las tres semanas me sentía como un hombre nuevo. Recuperé la potencia y las ganas que pensé que ya no volvían. Gracias a esto volvió mi confianza y autoestima."
}, {
  name: 'Jorge',
  age: 41,
  avatar: 'https://randomuser.me/api/portraits/men/52.jpg',
  title: 'Fuego nuevo en mi matrimonio de 15 años',
  body: 'La rutina y la baja energía nos estaban matando. Este protocolo mejoró mi flujo sanguíneo y el Bonus 5 sobre el caudal dio una satisfacción que mi esposa y yo no esperábamos.'
}, {
  name: 'Ricardo',
  age: 53,
  avatar: 'https://randomuser.me/api/portraits/men/53.jpg',
  title: 'A los 50 también se rinde como un león',
  body: "Muchos me decían que a esta edad 'es lo que toca'. Mentira. Entender como funciona mi cuerpo y optimizar mis hormonas naturalmente cambió las reglas del juego. Hoy disfruto del sexo como cuando era joven, mi dureza y rigidez volvieron y estoy muy contento. Gracias."
}];
export function Testimonials() {
  return <section className="py-24 bg-brand-dark relative overflow-hidden border-t border-brand-cardBorder" data-id="element-197">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-brand-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-198"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-200">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-brand-gold/30 bg-brand-gold/10 text-brand-gold text-sm font-semibold tracking-wide mb-6" data-id="element-201">
            <Users className="w-4 h-4" data-id="element-202" />
            HISTORIAS DE PODER
          </div>

          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-203">
            No estás solo. Más de{' '}
            <span className="text-brand-gold italic" data-id="element-204">12,000 hombres</span>
            <br className="hidden sm:block" data-id="element-205" /> ya han descifrado el Código.
          </h2>

          <div className="flex items-center justify-center gap-2 mt-6" data-id="element-206">
            <div className="flex" data-id="element-207">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-208" />)}
            </div>
            <span className="text-brand-muted text-sm font-medium ml-2" data-id="element-209">
              4.9 / 5 basado en testimonios verificados
            </span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-210">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index % 3 * 0.1,
          duration: 0.5
        }} className="bg-brand-card border border-brand-cardBorder rounded-2xl p-7 relative hover:border-brand-gold/40 transition-all group flex flex-col" data-id="element-211">
              {/* Decorative quote icon */}
              <Quote className="absolute top-5 right-5 w-8 h-8 text-brand-gold/15 group-hover:text-brand-gold/30 transition-colors" data-id="element-212" />

              {/* Header: avatar + name + age */}
              <div className="flex items-center gap-4 mb-4" data-id="element-213">
                <div className="relative flex-shrink-0" data-id="element-214">
                  <img src={t.avatar} alt={`Retrato de ${t.name}`} loading="lazy" className="w-14 h-14 rounded-full object-cover border-2 border-brand-gold/40 shadow-[0_0_15px_rgba(212,162,76,0.15)]" data-id="element-215" />
                  <div className="absolute -bottom-1 -right-1 bg-brand-dark rounded-full p-0.5 border border-brand-cardBorder" data-id="element-216">
                    <BadgeCheck className="w-4 h-4 text-brand-gold fill-brand-gold/20" data-id="element-217" />
                  </div>
                </div>
                <div data-id="element-218">
                  <div className="flex items-center gap-1.5" data-id="element-219">
                    <h4 className="text-white font-bold text-base" data-id="element-220">{t.name}</h4>
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-brand-gold/10 border border-brand-gold/30 text-[10px] font-semibold text-brand-gold uppercase tracking-wider" data-id="element-221">
                      Verificado
                    </span>
                  </div>
                  <p className="text-xs text-brand-muted font-medium mt-0.5" data-id="element-222">
                    {t.age} años · Cliente real
                  </p>
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-0.5 mb-4" data-id="element-223">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-224" />)}
              </div>

              {/* Title */}
              <h3 className="font-serif text-lg font-bold text-brand-gold mb-3 leading-snug italic" data-id="element-225">
                "{t.title}"
              </h3>

              {/* Body */}
              <p className="text-brand-text/80 text-sm leading-relaxed flex-1" data-id="element-226">
                {t.body}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}